var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0148 11.0341C16.8959 9.50166 19.1069 9.50165 19.9881 11.0341L26.6905 22.6905C27.569 24.2183 26.4662 26.1245 24.7039 26.1245H11.299C9.53665 26.1245 8.43385 24.2183 9.31232 22.6905L16.0148 11.0341ZM18.9045 11.6572C18.5039 10.9606 17.4989 10.9606 17.0984 11.6572L10.396 23.3136C9.99665 24.0081 10.4979 24.8745 11.299 24.8745H24.7039C25.5049 24.8745 26.0062 24.0081 25.6069 23.3136L18.9045 11.6572Z",
    fill: "#EA011D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0014 14.8745C18.3466 14.8745 18.6264 15.1544 18.6264 15.4995V18.8329C18.6264 19.1781 18.3466 19.4579 18.0014 19.4579C17.6563 19.4579 17.3764 19.1781 17.3764 18.8329V15.4995C17.3764 15.1544 17.6563 14.8745 18.0014 14.8745Z",
    fill: "#EA011D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4279 21.7007C18.6844 21.9316 18.7052 22.3268 18.4743 22.5834L18.466 22.5926C18.2351 22.8492 17.8399 22.87 17.5833 22.6391C17.3268 22.4082 17.306 22.013 17.5369 21.7564L17.5452 21.7472C17.7761 21.4906 18.1713 21.4698 18.4279 21.7007Z",
    fill: "#EA011D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningError);
export default __webpack_public_path__ + "static/media/warning_error.03d8f6ca2abd6c3153767bb81b8e67ca.svg";
export { ForwardRef as ReactComponent };